module.exports = __webpack_public_path__ + "img/our-history-sideimage.1c3ab8b3.jpg";